module.exports = __webpack_public_path__ + "img/neat.2e73d0a4.svg";